export default __webpack_public_path__ + "images/64e30f923409c9650945c12d6ae197d4-holiday_mobile.webp";